export default "__VITE_ASSET__CYqo9fiG__"